export const MEDICAL_TASK_KEY_TO_ID: Record<string, number> = {
    primary_physician: 6,
    specialty_physicians: 7,
    medical_history: 8,
    current_medications: 9,
    caregiver_info: 10,
    medical_equipment: 11,
    organ_donation: 12,
    current_therapy: 13,
};

export const PERSONAL_TASK_KEY_TO_ID: Record<string, number> = {
    personal_info: 1,
    employment_info: 2,
    spouse_info: 3,
    children_info: 4,
    pet_info: 5,
};

export const FINANCE_TASK_KEY_TO_ID: Record<string, number> = {
    accountant: 46,
    attorney: 47,
    investment_advisor: 48,
    insurance_agent: 49,
    tax_advisor: 50,
    credit_cards: 51,
    banking: 52,
    investments: 53,
    loans: 54,
    crypto: 55,
};

export const PROPERTY_TASK_KEY_TO_ID: Record<string, number> = {
    home_ownership: 82,
    homeowners_insurance: 83,
    cellphone: 85,
    home_inventory: 86,
    gas_utility: 87,
    electricity: 88,
    waste: 89,
    water_sewer: 90,
    home_security: 91,
    cable_streaming: 92,
    lawn_service: 93,
    pest_control: 94,
    pool_service: 95,
    gym_membership: 96,
};

export const MEDICAL_TASKS_CONFIG = [
  { title: 'Primary Care Physician', id: 6, inputScreen: 'PrimaryPhysicianIntro', dataScreen: 'PrimaryPhysicianData' },
  { title: 'Specialty Physicians', id: 7, inputScreen: 'SpecialtyPhysicianIntro', dataScreen: 'SpecialtyPhysicianData' },
  { title: 'Medical History', id: 8, inputScreen: 'MedicalHistoryIntro', dataScreen: 'MedicalHistoryData' },
  { title: 'Current Medications', id: 9, inputScreen: 'MedicationsIntro', dataScreen: 'MedicationsData' },
  { title: 'Caregiver Information', id: 10, inputScreen: 'CaregiverIntro', dataScreen: 'CaregiverData' },
  { title: 'Medical Equipment', id: 11, inputScreen: 'MedicalEquipmentIntro', dataScreen: 'MedicalEquipmentData' },
  { title: 'Organ Donation', id: 12, inputScreen: 'OrganDonorIntro', dataScreen: 'OrganDonorData' },
  { title: 'Current Therapy', id: 13, inputScreen: 'TreatmentsIntro', dataScreen: 'TreatmentsData' },
];

export const PERSONAL_TASKS_CONFIG = [
  { title: 'Identifying Information', id: 1, inputScreen: 'PersonalInfoIntro', dataScreen: 'PersonalInfoData' },
  { title: 'Employment Information', id: 2, inputScreen: 'EmploymentInfoIntro', dataScreen: 'EmploymentInfoData' },
  { title: 'Spouse Information', id: 3, inputScreen: 'SpouseInfoIntro', dataScreen: 'SpouseInfoData' },
  { title: 'Children Information', id: 4, inputScreen: 'ChildrenInfoIntro', dataScreen: 'ChildrenInfoData' },
  { title: 'Pet Information', id: 5, inputScreen: 'PetInfoIntro', dataScreen: 'PetInfoData' },
];

export const FINANCE_TASKS_CONFIG = [
  { title: 'Accountant', id: 46, inputScreen: 'AccountantInfoIntro', dataScreen: 'AccountantInfoData' },
  { title: 'Attorney', id: 47, inputScreen: 'AttorneyInfoIntro', dataScreen: 'AttorneyInfoData' },
  { title: 'Investment Advisor', id: 48, inputScreen: 'InvestmentAdvisorInfoIntro', dataScreen: 'InvestmentAdvisorInfoData' },
  { title: 'Insurance Agent', id: 49, inputScreen: 'InsuranceAgentInfoIntro', dataScreen: 'InsuranceAgentInfoData' },
  { title: 'Tax Advisor', id: 50, inputScreen: 'TaxAdvisorInfoIntro', dataScreen: 'TaxAdvisorInfoData' },
  { title: 'Credit Cards', id: 51, inputScreen: 'CreditCardInfoIntro', dataScreen: 'CreditCardInfoData' },
  { title: 'Banking', id: 52, inputScreen: 'BankingInfoIntro', dataScreen: 'BankingInfoData' },
  { title: 'Investment Accounts', id: 53, inputScreen: 'InvestmentsInfoIntro', dataScreen: 'InvestmentsInfoData' },
  { title: 'Loans', id: 54, inputScreen: 'LoanInfoIntro', dataScreen: 'LoanInfoData' },
  { title: 'Crypto Currency', id: 55, inputScreen: 'CryptoInfoIntro', dataScreen: 'CryptoInfoData' },
];

export const PROPERTY_TASKS_CONFIG = [
  { title: 'Living Arrangements', id: 82, inputScreen: 'HomeOwnershipIntro', dataScreen: 'HomeOwnershipData' },
  { title: 'Home owners Insurance', id: 83, inputScreen: 'HomeownersInsuranceIntro', dataScreen: 'HomeownersInsuranceData' },
  { title: 'Cellphone Provider', id: 85, inputScreen: 'CellphoneProviderIntro', dataScreen: 'CellphoneProviderData' },
  { title: 'Valuables & Home Inventory', id: 86, inputScreen: 'HomeInventoryIntro', dataScreen: 'HomeInventoryData' },
  { title: 'Gas Utility Provider', id: 87, inputScreen: 'GasProviderIntro', dataScreen: 'GasProviderData' },
  { title: 'Electricity Provider', id: 88, inputScreen: 'ElectricProviderIntro', dataScreen: 'ElectricProviderData' },
  { title: 'Trash/Waste Provider', id: 89, inputScreen: 'WasteProviderIntro', dataScreen: 'WasteProviderData' },
  { title: 'Water/Sewer Provider', id: 90, inputScreen: 'WaterSewerProviderIntro', dataScreen: 'WaterSewerProviderData' },
  { title: 'Home Security Provider', id: 91, inputScreen: 'HomeSecurityIntro', dataScreen: 'HomeSecurityData' },
  { title: 'Cable TV or Streaming Service', id: 92, inputScreen: 'StreamingServiceProviderIntro', dataScreen: 'StreamingServiceProviderData' },
  { title: 'Lawn Service Provider', id: 93, inputScreen: 'LawnServiceProviderIntro', dataScreen: 'LawnServiceProviderData' },
  { title: 'Pest Control Provider', id: 94, inputScreen: 'PestControlProviderIntro', dataScreen: 'PestControlProviderData' },
  { title: 'Pool Service Provider', id: 95, inputScreen: 'PoolServiceProviderIntro', dataScreen: 'PoolServiceProviderData' },
  { title: 'Gym/Health Club Membership', id: 96, inputScreen: 'GymMembershipIntro', dataScreen: 'GymMembershipData' },
];

export const FINAL_WISHES_TASKS_CONFIG = [
  { title: 'Final Body Arrangements', id: 64, inputScreen: 'BodyArrangementsIntro', dataScreen: 'BodyArrangementsData' },
  { title: 'Funeral Home Selection', id: 65, inputScreen: 'FuneralHomeIntro', dataScreen: 'FuneralHomeData' },
  { title: 'Casket/Urn Selection', id: 66, inputScreen: 'CasketUrnIntro', dataScreen: 'CasketUrnData' },
  { title: 'Funeral/Memorial Service', id: 67, inputScreen: 'MemorialServiceIntro', dataScreen: 'MemorialServiceData' },
  { title: 'Tributes/Charities/Donations', id: 68, inputScreen: 'TributeDonationsIntro', dataScreen: 'TributeDonationsData' },
  { title: 'Special Instructions', id: 69, inputScreen: 'FuneralInstructionsIntro', dataScreen: 'FuneralInstructionsData' },
  { title: 'Officiant Preference', id: 70, inputScreen: 'OfficiantIntro', dataScreen: 'OfficiantData' },
  { title: 'Letter to Loved Ones', id: 71, inputScreen: 'LetterToLovedOnesIntro', dataScreen: 'LetterToLovedOnesData' },
  { title: 'Prayers and Readings', id: 72, inputScreen: 'PrayersReadingsIntro', dataScreen: 'PrayersReadingsData' },
  { title: 'Food Preferences', id: 73, inputScreen: 'FoodPreferencesIntro', dataScreen: 'FoodPreferencesData' },
  { title: 'Special Music/Playlists', id: 74, inputScreen: 'MusicIntro', dataScreen: 'MusicData' },
  { title: 'Select Pallbearers', id: 75, inputScreen: 'PallBearerIntro', dataScreen: 'PallBearerData' },
  { title: 'Rituals or Traditions', id: 76, inputScreen: 'TraditionsRitualsIntro', dataScreen: 'TraditionsRitualsData' },
  { title: 'Wake Details', id: 77, inputScreen: 'WakeDetailsIntro', dataScreen: 'WakeDetailsData' },
  { title: 'Plan Eulogy', id: 78, inputScreen: 'EulogyIntro', dataScreen: 'EulogyData' },
  { title: 'Burial Plot', id: 79, inputScreen: 'BurialPlotIntro', dataScreen: 'BurialPlotData' },
  { title: 'Obituary details', id: 80, inputScreen: 'ObituaryDetailsIntro', dataScreen: 'ObituaryDetailsData' },
  { title: 'Headstone or Grave Marker Details', id: 81, inputScreen: 'HeadstoneDetailsIntro', dataScreen: 'HeadstoneDetailsData' },
];

// ============================================
// HEALTHCARE DIRECTIVES (Legal Documents)
// ============================================
export const HEALTHCARE_DIRECTIVES_TASK_KEY_TO_ID: Record<string, number> = {
  advance_directive: 56,
  medical_poa: 61,
  hipaa_authorization: 500,
  dnr_order: 58,
};

export const HEALTHCARE_DIRECTIVES_TASKS_CONFIG = [
  { title: 'Advance Directive/Living Will', id: 56, inputScreen: 'AdvanceDirectiveIntro', dataScreen: 'AdvanceDirectiveData' },
  { title: 'Medical Power of Attorney', id: 61, inputScreen: 'MedicalPOAPreferencesIntro', dataScreen: 'MedicalPOAPreferencesData' },
  { title: 'HIPAA Authorization', id: 500, inputScreen: 'HIPAAAuthorizationIntro', dataScreen: 'HIPAAAuthorizationData' },
  { title: 'DNR Order', id: 58, inputScreen: 'DNRPreferencesIntro', dataScreen: 'DNRPreferencesData' },
];

// ============================================
// ESTATE PLANNING (Legal Documents)
// ============================================
export const ESTATE_PLANNING_TASK_KEY_TO_ID: Record<string, number> = {
  last_will: 501,
  living_trust: 63,
  financial_poa: 502,
  beneficiary_designations: 503,
};

export const ESTATE_PLANNING_TASKS_CONFIG = [
  { title: 'Last Will & Testament', id: 501, inputScreen: 'WillIntro', dataScreen: 'WillData' },
  { title: 'Living Trust', id: 63, inputScreen: 'LivingTrustPreferencesIntro', dataScreen: 'LivingTrustPreferencesData' },
  { title: 'Financial Power of Attorney', id: 502, inputScreen: 'FinancialPOAIntro', dataScreen: 'FinancialPOAData' },
  { title: 'Beneficiary Designations', id: 503, inputScreen: 'BeneficiaryDesignationsIntro', dataScreen: 'BeneficiaryDesignationsData' },
];

// ============================================
// CARE PREFERENCES (Personal Wishes - No Legal Doc Required)
// ============================================
export const CARE_PREFERENCES_TASK_KEY_TO_ID: Record<string, number> = {
  ltc_preferences: 57,
  end_of_life_wishes: 504,
};

export const CARE_PREFERENCES_TASKS_CONFIG = [
  { title: 'Long Term Care Preferences', id: 57, inputScreen: 'LTCPreferencesIntro', dataScreen: 'LTCPreferencesData' },
  { title: 'End-of-Life Treatment Wishes', id: 504, inputScreen: 'EndOfLifeWishesIntro', dataScreen: 'EndOfLifeWishesData' },
];

// ============================================
// DEPRECATED: FINAL_CARE_TASKS_CONFIG
// Replaced by: HEALTHCARE_DIRECTIVES, ESTATE_PLANNING, CARE_PREFERENCES
// Keep temporarily for backward compatibility during migration
// ============================================
export const FINAL_CARE_TASKS_CONFIG = [
  { title: 'Advance Directive/POLST', id: 56, inputScreen: 'AdvanceDirectiveIntro', dataScreen: 'AdvanceDirectiveData' },
  { title: 'Long Term Care Preferences', id: 57, inputScreen: 'LTCPreferencesIntro', dataScreen: 'LTCPreferencesData' },
  { title: 'Do Not Resuscitate Preference', id: 58, inputScreen: 'DNRPreferencesIntro', dataScreen: 'DNRPreferencesData' },
  { title: 'Breathing Tube Preference', id: 59, inputScreen: 'BreathingTubePreferencesIntro', dataScreen: 'BreathingTubePreferencesData' },
  { title: 'Feeding Tube Preference', id: 60, inputScreen: 'FeedingTubePreferencesIntro', dataScreen: 'FeedingTubePreferencesData' },
  { title: 'Medical Power of Attorney', id: 61, inputScreen: 'MedicalPOAPreferencesIntro', dataScreen: 'MedicalPOAPreferencesData' },
  { title: 'Living Trust', id: 63, inputScreen: 'LivingTrustPreferencesIntro', dataScreen: 'LivingTrustPreferencesData' },
];

export const PASSWORDS_TASK_KEY_TO_ID: Record<string, number> = {
  financial_passwords: 100,
  social_passwords: 101,
  utilities_passwords: 102,
  communication_passwords: 103,
  insurance_passwords: 104,
  medical_passwords: 105,
  online_accounts_passwords: 106,
  memberships_passwords: 107,
  security_passwords: 108,
  digital_passwords: 109,
  misc_passwords: 110,
};

export const PASSWORDS_TASKS_CONFIG = [
  { title: 'Financial Passwords', id: 100, inputScreen: 'PasswordsInputScreen', dataScreen: 'PasswordsDataScreen', category: 'financial' },
  { title: 'Social Passwords', id: 101, inputScreen: 'PasswordsInputScreen', dataScreen: 'PasswordsDataScreen', category: 'social' },
  { title: 'Utilities Passwords', id: 102, inputScreen: 'PasswordsInputScreen', dataScreen: 'PasswordsDataScreen', category: 'utilities' },
  { title: 'Communication Passwords', id: 103, inputScreen: 'PasswordsInputScreen', dataScreen: 'PasswordsDataScreen', category: 'communication' },
  { title: 'Insurance Passwords', id: 104, inputScreen: 'PasswordsInputScreen', dataScreen: 'PasswordsDataScreen', category: 'insurance' },
  { title: 'Medical Passwords', id: 105, inputScreen: 'PasswordsInputScreen', dataScreen: 'PasswordsDataScreen', category: 'medical' },
  { title: 'Online Accounts Passwords', id: 106, inputScreen: 'PasswordsInputScreen', dataScreen: 'PasswordsDataScreen', category: 'online-accounts' },
  { title: 'Memberships Passwords', id: 107, inputScreen: 'PasswordsInputScreen', dataScreen: 'PasswordsDataScreen', category: 'memberships' },
  { title: 'Security Passwords', id: 108, inputScreen: 'PasswordsInputScreen', dataScreen: 'PasswordsDataScreen', category: 'security' },
  { title: 'Digital Passwords', id: 109, inputScreen: 'PasswordsInputScreen', dataScreen: 'PasswordsDataScreen', category: 'digital' },
  { title: 'Miscellaneous Passwords', id: 110, inputScreen: 'PasswordsInputScreen', dataScreen: 'PasswordsDataScreen', category: 'misc' },
];

export const CONTACTS_TASK_KEY_TO_ID: Record<string, number> = {
  family_contacts: 200,
  friends_contacts: 201,
  medical_contacts: 202,
  legal_contacts: 203,
  property_contacts: 204,
  business_contacts: 205,
  eol_contacts: 206,
  spiritual_contacts: 207,
  pet_contacts: 208,
  personal_contacts: 209,
  other_contacts: 210,
};

export const CONTACTS_TASKS_CONFIG = [
  { title: 'Family Contacts', id: 200, inputScreen: 'ContactsInputScreen', dataScreen: 'ContactsDataScreen', category: 'family' },
  { title: 'Friends Contacts', id: 201, inputScreen: 'ContactsInputScreen', dataScreen: 'ContactsDataScreen', category: 'friends' },
  { title: 'Medical Contacts', id: 202, inputScreen: 'ContactsInputScreen', dataScreen: 'ContactsDataScreen', category: 'medical' },
  { title: 'Legal Contacts', id: 203, inputScreen: 'ContactsInputScreen', dataScreen: 'ContactsDataScreen', category: 'legal' },
  { title: 'Property Contacts', id: 204, inputScreen: 'ContactsInputScreen', dataScreen: 'ContactsDataScreen', category: 'property' },
  { title: 'Business Contacts', id: 205, inputScreen: 'ContactsInputScreen', dataScreen: 'ContactsDataScreen', category: 'business' },
  { title: 'EOL Contacts', id: 206, inputScreen: 'ContactsInputScreen', dataScreen: 'ContactsDataScreen', category: 'eol' },
  { title: 'Spiritual Contacts', id: 207, inputScreen: 'ContactsInputScreen', dataScreen: 'ContactsDataScreen', category: 'spiritual' },
  { title: 'Pet Contacts', id: 208, inputScreen: 'ContactsInputScreen', dataScreen: 'ContactsDataScreen', category: 'pet' },
  { title: 'Personal Contacts', id: 209, inputScreen: 'ContactsInputScreen', dataScreen: 'ContactsDataScreen', category: 'personal' },
  { title: 'Other Contacts', id: 210, inputScreen: 'ContactsInputScreen', dataScreen: 'ContactsDataScreen', category: 'other' },
];

export const EXPENSES_TASK_KEY_TO_ID: Record<string, number> = {
  housing_expenses: 300,
  taxes_expenses: 301,
  utilities_expenses: 302,
  insurance_expenses: 303,
  credit_cards_expenses: 304,
  loans_expenses: 305,
  healthcare_expenses: 306,
  memberships_expenses: 307,
  subscriptions_expenses: 308,
  investments_expenses: 309,
  personal_expenses: 310,
  other_expenses: 311,
};

export const EXPENSES_TASKS_CONFIG = [
  { title: 'Housing Expenses', id: 300, inputScreen: 'ExpensesInputScreen', dataScreen: 'ExpensesDataScreen', category: 'housing' },
  { title: 'Taxes Expenses', id: 301, inputScreen: 'ExpensesInputScreen', dataScreen: 'ExpensesDataScreen', category: 'taxes' },
  { title: 'Utilities Expenses', id: 302, inputScreen: 'ExpensesInputScreen', dataScreen: 'ExpensesDataScreen', category: 'utilities' },
  { title: 'Insurance Expenses', id: 303, inputScreen: 'ExpensesInputScreen', dataScreen: 'ExpensesDataScreen', category: 'insurance' },
  { title: 'Credit Cards Expenses', id: 304, inputScreen: 'ExpensesInputScreen', dataScreen: 'ExpensesDataScreen', category: 'credit-cards' },
  { title: 'Loans Expenses', id: 305, inputScreen: 'ExpensesInputScreen', dataScreen: 'ExpensesDataScreen', category: 'loans' },
  { title: 'Healthcare Expenses', id: 306, inputScreen: 'ExpensesInputScreen', dataScreen: 'ExpensesDataScreen', category: 'healthcare' },
  { title: 'Memberships Expenses', id: 307, inputScreen: 'ExpensesInputScreen', dataScreen: 'ExpensesDataScreen', category: 'memberships' },
  { title: 'Subscriptions Expenses', id: 308, inputScreen: 'ExpensesInputScreen', dataScreen: 'ExpensesDataScreen', category: 'subscriptions' },
  { title: 'Investments Expenses', id: 309, inputScreen: 'ExpensesInputScreen', dataScreen: 'ExpensesDataScreen', category: 'investments' },
  { title: 'Personal Expenses', id: 310, inputScreen: 'ExpensesInputScreen', dataScreen: 'ExpensesDataScreen', category: 'personal' },
  { title: 'Other Expenses', id: 311, inputScreen: 'ExpensesInputScreen', dataScreen: 'ExpensesDataScreen', category: 'other' },
];

// Loyalty Points Tasks Configuration
export const LOYALTY_POINTS_TASK_KEY_TO_ID: { [key: string]: number } = {
  'retail-shopping': 401,
  'travel-hospitality': 402,
  'food-beverage': 403,
  'credit-cards-financial': 404,
  'health-wellness': 405,
  'other': 406,
};

export const LOYALTY_POINTS_TASKS_CONFIG = [
  { title: 'Retail and Shopping', id: 401, inputScreen: 'LoyaltyPointInputScreen', dataScreen: 'LoyaltyPointDataScreen', category: 'retail-shopping' },
  { title: 'Travel and Hospitality', id: 402, inputScreen: 'LoyaltyPointInputScreen', dataScreen: 'LoyaltyPointDataScreen', category: 'travel-hospitality' },
  { title: 'Food and Beverage', id: 403, inputScreen: 'LoyaltyPointInputScreen', dataScreen: 'LoyaltyPointDataScreen', category: 'food-beverage' },
  { title: 'Credit Cards and Financial', id: 404, inputScreen: 'LoyaltyPointInputScreen', dataScreen: 'LoyaltyPointDataScreen', category: 'credit-cards-financial' },
  { title: 'Health and Wellness', id: 405, inputScreen: 'LoyaltyPointInputScreen', dataScreen: 'LoyaltyPointDataScreen', category: 'health-wellness' },
  { title: 'Other', id: 406, inputScreen: 'LoyaltyPointInputScreen', dataScreen: 'LoyaltyPointDataScreen', category: 'other' },
]; 